import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { useSettings, useUpdateSettings } from '../api/queries';
import { Card } from '../ui';
import { APP_VERSION, announced, isNewer, newestAnnounced } from '../lib/releases';
import { ReleaseEntry } from '../shell/WhatsNew';

/**
 * Every release there were notes for, newest first (2026-09-25) — minors and
 * majors only; a fix is not news.
 *
 * Reading them all is having seen them all: the note that pops up does not come
 * back for anything on this page.
 */
export function ReleaseNotes(): ReactElement {
  const settings = useSettings();
  const { mutate } = useUpdateSettings();
  const seen = settings.data?.releaseNotesSeen ?? null;
  const loaded = settings.isSuccess;
  useEffect(() => {
    const newest = newestAnnounced();
    if (loaded && (seen === null || isNewer(newest, seen))) mutate({ releaseNotesSeen: newest });
  }, [loaded, seen, mutate]);

  return (
    <div className="page stack-lg">
      <div className="stack" style={{ gap: 4 }}>
        <h1 className="t-title">Release notes</h1>
        <p className="mono">you are on Ptitim {APP_VERSION}</p>
      </div>
      {announced().map((release) => (
        <Card key={release.version}>
          <ReleaseEntry release={release} />
        </Card>
      ))}
    </div>
  );
}
